module.exports = __webpack_public_path__ + "static/media/upload-icon-dark.bc201a21.svg";